var _defs, _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277 277",
    width: 277,
    height: 277,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 10h257v256.62h-257z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: none;stroke: #ff7700;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2;stroke-dasharray: 109 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m10.4 10h93.3v93h-93.3zm232.8 233.2h23.8v23.4h-23.8zm-45.7-0.1h23.8v22.4h-47.6v-45.7h23v-23.1h23.5v-46.1h23.8v22.7h22.6v23.4h-22.6v23.4h-46.5zm-70.7-46.8h23v-23.5h-22.3v-23.4h22.3v-23.4h-22.6v23.4h-23.9v-23.4h23.5v-69.6h23.8v69.6h23v23.4h22.7v-23.4h23.8v23.4h-22.6v23.4h-23.8v46.1h-23.1v46.5h-23.8zm116-70.3h23.8v23.5h-23.8zm-185.9 0h23.8v23.4h-23.8zm-46.5 0h23.8v23.4h-23.8zm116.4-116h23.8v23.4h-23.8zm-116.8 163.3h93.3v92.9h-93.3zm22.7 70.4h48v-47.8h-48zm140.6-233.6h93.3v92.9h-93.3zm22.7 70.4h48v-47.8h-48zm-163 0h48v-47.8h-48z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1 1h275v275h-275z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.52105dcd1b10ebceca1e61753a0549cc.svg";
export { ForwardRef as ReactComponent };